import { useEffect, useState, memo } from "react";
import { Breadcrumb } from "antd";
import { FundOutlined, HomeOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { getDateTime } from "../../helper/helper";
import { Link } from "react-router-dom";

function Breadcrumbs({ data = ["Overview", "Halotel"], text = true }) {
  const [dateNow, setDateNow] = useState("");

  useEffect(() => {
    setDateNow(getDateTime());
  }, []);

  return (
    <ContainerBreadcrumb>
      <div className="containerBreadcrumb">
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>
            <Link to="">
              <HomeOutlined /> Home
            </Link>
          </Breadcrumb.Item>
          {data.map((item, index) => (
            <Breadcrumb.Item key={index}>{item}</Breadcrumb.Item>
          ))}
        </Breadcrumb>
        <div className="date-time">{dateNow}</div>
      </div>
      {text && (
      <div className="dashboard-marketing">
        <FundOutlined />
        <span className="marketing__title">
          <b>Marketing </b>Dashboard
        </span>
      </div>
      )}
    </ContainerBreadcrumb>
  );
}

export default memo(Breadcrumbs);
const ContainerBreadcrumb = styled.div`
  padding-top: 4.125rem;
  .containerBreadcrumb {
    display: flex;
    justify-content: space-between;

    .ant-breadcrumb-link {
      font-family: "Bai Jamjuree", "Trebuchet MS", sans-serif;
      font-size: 15px;
    }

    .ant-breadcrumb-separator {
      font-size: 15px;
    }

    svg {
      font-size: 15px;
    }

    .date-time {
      display: flex;
      align-items: center;
      color: #666666;
    }
  }
  .dashboard-marketing {
    /* margin-left: 30px; */
  }
  .marketing__title {
    padding-left: 10px;
    font-size: 1.375rem;
    font-weight: 500;
    color: #505050;
    text-shadow: #fff 0 1px;
  }

  @media(max-width: 576px){
    .containerBreadcrumb .date-time{
      display: none;
    }

    .marketing__title{
      font-size: 1.25rem;
    }

    .ant-breadcrumb{
      margin: 10px 0 !important;
    }
  }
`;
